<template>
  <div
    class="action-buttons-grid"
    :class="{ 'action-buttons-grid--dark': $vuetify.theme.dark }"
  >
    <button
      type="button"
      class="action-btn"
      :aria-label="$t('clear')"
      @click="$emit('clear')"
    >
      <v-icon size="16">fal fa-trash-alt</v-icon>
      <span class="action-btn__label">{{ $t("clear") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :aria-label="$t('tables')"
      @click="$emit('tables')"
    >
      <v-icon size="16">fal fa-utensils</v-icon>
      <span class="action-btn__label">{{ $t("tables") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :aria-label="$t('bill')"
      @click="$emit('bill')"
    >
      <v-icon size="16">fal fa-receipt</v-icon>
      <span class="action-btn__label">{{ $t("bill") }}</span>
    </button>
    <button
      type="button"
      class="action-btn"
      :aria-label="$t('all_product')"
      @click="$emit('products')"
    >
      <v-icon size="16">fal fa-box</v-icon>
      <span class="action-btn__label">{{ $t("all_product") }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionButtonsRestaurant",
};
</script>

<style scoped>
/* PosSmart v2: 4-column icon+label buttons */
.action-buttons-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 3px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease,
    background-color 0.15s ease;
}

.action-btn:hover {
  border-color: #5b39c9;
  color: #5b39c9;
  background: #f3f0fc;
}

.action-btn:focus-visible {
  outline: 2px solid #5b39c9;
  outline-offset: 1px;
}

.action-buttons-grid--dark .action-btn {
  border-color: #2f333a;
  background: #20252d;
  color: #cbd5e1;
}

.action-buttons-grid--dark .action-btn:hover {
  background: #2a2448;
  color: #c4b5fd;
}
</style>
